import { createContext, useContext, useEffect, useState } from "react";

const CartContext = createContext(null);

export const useCart = () => useContext(CartContext);

export function CartProvider({ children }) {
  const [items, setItems] = useState(() => {
    try { return JSON.parse(localStorage.getItem("trotix_cart") || "[]"); } catch { return []; }
  });

  useEffect(() => {
    localStorage.setItem("trotix_cart", JSON.stringify(items));
  }, [items]);

  const add = (product, qty = 1) => {
    setItems((prev) => {
      const ex = prev.find((i) => i.product_id === product.id);
      if (ex) return prev.map((i) => i.product_id === product.id ? { ...i, qty: Math.min(i.qty + qty, product.stock) } : i);
      return [...prev, { product_id: product.id, name: product.name, price: product.price, stock: product.stock, image: (product.images || [])[0]?.path || "", qty: Math.min(qty, product.stock) }];
    });
  };
  const setQty = (id, qty) => setItems((prev) => prev.map((i) => i.product_id === id ? { ...i, qty: Math.max(1, Math.min(qty, i.stock || 99)) } : i));
  const remove = (id) => setItems((prev) => prev.filter((i) => i.product_id !== id));
  const clear = () => setItems([]);
  const total = items.reduce((s, i) => s + i.price * i.qty, 0);
  const count = items.reduce((s, i) => s + i.qty, 0);

  return <CartContext.Provider value={{ items, add, setQty, remove, clear, total, count }}>{children}</CartContext.Provider>;
}
